import React from 'react';
import { Link } from 'react-router-dom';
import useDeleteTalentFromPool from '../../../../../../hooks/talents/useDeleteTalentFromPool';
import useUpdateTalentStatus from '../../../../../../hooks/talents/useUpdateTalentStatus';
import './talentApplicationCard.css';
import { starIcon, scheduleIcon,userChefIcon, timerIcon  } from '../../../../../../utils/icons';
import useSignedImage from '../../../../../../hooks/useSignedImage';

const TalentApplicationCard = ({ data, onDeleteSuccess, onAcceptSuccess, onError }) => {
    const { deleteTalentFromPool } = useDeleteTalentFromPool();
    const { updateTalentStatus } = useUpdateTalentStatus();
    const { id, name, position, available, schedule, employeeId, profileImageUrl } = data
    const { imageUrl: signedEmployeeImageUrl } = useSignedImage(profileImageUrl, '/default-employee.png');

    const handleDeleteTalent = async () => {
        try {
            await deleteTalentFromPool(id);
            onDeleteSuccess();
        } catch (error) {
            onError && onError('Error al rechazar el talento: ' + error.message);
        }
    };

    const handleAcceptTalent = async () => {
        try {
            await updateTalentStatus(id, 'accepted');
            onAcceptSuccess();
        } catch (error) {
            console.error('Error accepting talent:', error);
            onError && onError('Error al aceptar el talento: ' + error.message);
        }
    };

    return (
        <div className="talent-application-card__container">
            <div className="talent-application-card__col-1">
                <img className="talent-application-card__image" src={signedEmployeeImageUrl} alt={name} />
                <div className="talent-application-card__info ">
                    <p id="name-application-card">{name}</p>
                </div>
            </div>
            <div className="talent-application-card__col-2-container">
                <div className="talent-application-card__col-2">
                    <div className="talent-application-card__info-container">
                        <div className="talent-application-card__icon-container">
                          {userChefIcon}
                        </div>
                        <div>
                            <p><strong>Cargo:</strong></p>
                            <p>{position}</p>
                        </div>
                    </div>
                    <div className="talent-application-card__info-container">
                        <div className="talent-application-card__icon-container">
                         {starIcon}
                        </div>
                        <div>
                            <p><strong>Experiencia:</strong></p>
                            <p>3 años</p>
                        </div>
                    </div>
                </div>
                <div className="talent-application-card__col-2">
                    <div className="talent-application-card__info-container">
                        <div className="talent-application-card__icon-container">
                        {scheduleIcon}
                        </div>
                        <div>
                            <p><strong>Disponibilidad:</strong></p>
                            <p>{available}</p>
                        </div>
                    </div>
                    <div className="talent-application-card__info-container">
                        <div className="talent-application-card__icon-container">
                        {timerIcon}
                        </div>
                        <div>
                            <p><strong>Jornada:</strong></p>
                            <p>{schedule}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="talent-application-card__col-3">
                <div className="talent-application-card__button-container">
                    <Link to={`/empleados/${employeeId}`}>
                        <button className="talent-application-card__button">Perfil</button>
                    </Link>
                    <button onClick={handleAcceptTalent} className='talent-application-card__button'>
                        Aceptar
                    </button>
                    <button onClick={handleDeleteTalent} className='talent-application-card__button'>
                        Eliminar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TalentApplicationCard;

